var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"li-page"},[(!_vm.component)?_vm._t("default"):_vm._e(),(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"params":_vm.params,"query":_vm.query},on:{"subpage-submit":_vm.handleSubmit,"subpage-cancel":_vm.handleCancel}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }